import type { z } from "zod";
import { LayoutV1Schema } from "./V1.schema";

export const LayoutSchemas = {
  "layout@1": LayoutV1Schema,       
} as const;

/*
// Union the schema when the next version is created
export const AnyLayoutSchema = z.union([
  LayoutV1Schema,
  LayoutV2Schema,
]);
*/
export const AnyLayoutSchema = LayoutV1Schema;

export type AnyLayoutConfig = z.infer<typeof AnyLayoutSchema>;
